import { ref, reactive } from 'vue'
import http from '../api/http'

// 後台設定狀態
const backendConfig = ref({
  title: '後台管理系統',
  primary_color: '#6c757d',
  sidebar_collapsed: false
})

// 側邊欄收合狀態（運行時狀態，與設定分開）
const sidebarCollapsed = ref(false)

// 側邊欄懸停展開狀態
const sidebarHovered = ref(false)

// 載入狀態
const loading = ref(false)

// 載入後台設定
const loadBackendConfig = async () => {
  try {
    loading.value = true
    const response = await http.get('/api/admin/settings/backend-config')
    
    if (response.data) {
      backendConfig.value = {
        title: response.data.title || '後台管理系統',
        primary_color: response.data.primary_color || '#6c757d',
        sidebar_collapsed: response.data.sidebar_collapsed || false
      }
    }
  } catch (error) {
    console.error('載入後台設定失敗:', error)
    // 使用預設值，不顯示錯誤訊息
  } finally {
    loading.value = false
  }
}

// 更新後台設定
const updateBackendConfig = async (newConfig) => {
  try {
    loading.value = true
    const response = await http.post('/api/admin/settings/backend-config', newConfig)
    
    if (response.data.success) {
      // 更新本地狀態
      Object.assign(backendConfig.value, newConfig)
      return { success: true, message: '後台設定更新成功' }
    } else {
      return { success: false, message: response.data.message || '更新失敗' }
    }
  } catch (error) {
    console.error('更新後台設定失敗:', error)
    return { success: false, message: '更新失敗，請稍後再試' }
  } finally {
    loading.value = false
  }
}

// 獲取後台標題
const getBackendTitle = () => {
  return backendConfig.value.title
}


// 獲取主題色彩
const getPrimaryColor = () => {
  return backendConfig.value.primary_color
}

// 獲取側邊欄狀態
const getSidebarCollapsed = () => {
  return backendConfig.value.sidebar_collapsed
}

// 切換側邊欄收合狀態
const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value
}

// 設定側邊欄收合狀態
const setSidebarCollapsed = (collapsed) => {
  sidebarCollapsed.value = collapsed
}

// 獲取當前側邊欄收合狀態
const getCurrentSidebarCollapsed = () => {
  return sidebarCollapsed.value
}

// 設定側邊欄懸停狀態
const setSidebarHovered = (hovered) => {
  sidebarHovered.value = hovered
}

// 獲取側邊欄懸停狀態
const getSidebarHovered = () => {
  return sidebarHovered.value
}

// 獲取側邊欄實際顯示狀態（考慮懸停展開）
const getSidebarActualCollapsed = () => {
  // 如果設定了收合且沒有懸停，則顯示為收合
  return sidebarCollapsed.value && !sidebarHovered.value
}

export function useBackendSettings() {
  return {
    // 狀態
    backendConfig,
    sidebarCollapsed,
    sidebarHovered,
    loading,
    
    // 方法
    loadBackendConfig,
    updateBackendConfig,
    getBackendTitle,
    getPrimaryColor,
    getSidebarCollapsed,
    toggleSidebar,
    setSidebarCollapsed,
    getCurrentSidebarCollapsed,
    setSidebarHovered,
    getSidebarHovered,
    getSidebarActualCollapsed
  }
}
